import { render, staticRenderFns } from "./consumeCustomerList.vue?vue&type=template&id=36687978&scoped=true&"
import script from "./consumeCustomerList.vue?vue&type=script&lang=js&"
export * from "./consumeCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./consumeCustomerList.vue?vue&type=style&index=0&id=36687978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36687978",
  null
  
)

export default component.exports